import React from "react";

const FiatDepositIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="#DAF2EA"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.00012207" width="32" height="32" rx="16" fill="#DAF2EA" />
      <path
        d="M17.7779 12.5201H22.8409C23.4854 12.5247 24.0042 13.0507 24 13.6952V21.9051C24.0042 22.5495 23.4854 23.0755 22.8409 23.0801H9.15908C8.51462 23.0755 7.9958 22.5495 8.00003 21.9051V13.6952C7.9958 13.0507 8.51462 12.5247 9.15908 12.5201H14.2221"
        stroke="#022B1D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16 9.00012V17.9601"
        stroke="#022B1D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.952 16.04L16 17.96L18.0479 16.04"
        stroke="#022B1D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7421 17.7668H10.2464C10.2139 17.7668 10.1876 17.7932 10.1876 17.8257V19.3214C10.1876 19.3539 10.2139 19.3803 10.2464 19.3803H11.7421C11.7746 19.3803 11.801 19.3539 11.801 19.3214V17.8257C11.801 17.7932 11.7746 17.7668 11.7421 17.7668Z"
        stroke="#022B1D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M10.1876 21.1748H11.801" stroke="#022B1D" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M13.0707 21.1748H14.6841" stroke="#022B1D" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M15.9539 21.1748H17.5673" stroke="#022B1D" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M18.8364 21.1748H20.4499" stroke="#022B1D" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export default FiatDepositIcon;
